module.exports = __webpack_public_path__ + "static/media/info.88752404.svg";